import React from "react";

import { Typography, Tag, TagVariant } from "@packages/ds";

import * as S from "./AddonCta.style";

type AddonCtaProps = {
  title: string;
  body: string;
  tag?: string;
  tagVariant?: keyof typeof TagVariant;
  buttons: React.ReactNode;
};

const AddonCta = ({ title, body, tag, tagVariant, buttons }: AddonCtaProps) => (
  <S.AddonCtaWrapper>
    {tag && tagVariant && (
      <S.TagWrapper>
        <Tag variant={tagVariant}>{tag}</Tag>
      </S.TagWrapper>
    )}
    <S.AddonCtaTitle>{title}</S.AddonCtaTitle>
    <Typography.BodyText size="small">{body}</Typography.BodyText>
    <S.AddonCtaButtonWrapper>{buttons}</S.AddonCtaButtonWrapper>
  </S.AddonCtaWrapper>
);

export default AddonCta;
